export type PhraseBook = Record<string, string>;

const luganda: PhraseBook = {
    'Application form · Ministry Demo Portal':
        'Foomu y’okusaba · Oluyiiya lwa Minisitule',
    'Services · Ministry Demo Portal': 'Empeereza · Oluyiiya lwa Minisitule',
    'Ministry Demo Portal': 'Oluyiiya lwa Minisitule',
    'Republic of Uganda · Demo Ministry Portal':
        'Gwanga lya Uganda · Oluyiiya lwa Minisitule',
    'Welcome to the UGACCESS demonstration website':
        'Tusanyukidde ku mukutu gwa UGACCESS ogw’okulaga',
    'Make public services easier to use for every citizen':
        'Fuula empeereza z’abantu zibe nnyangu eri buli muntu',
    'Built as shared infrastructure': 'Ezikoleddwa ng’ebyuma ebyawamu',
    'Three steps to go live': 'Ebikubirizibwa bisatu okutandika',
    'Operator sign in': 'Yingira ng’omukola',
    'See the snippet': 'Laba ekitundu kya kola',
    'This sample government site shows how the UGACCESS SDK enhances access without changing ministry business logic.':
        'Omukutu guno ogw’okulaga gwulaga nga UGACCESS SDK bweyongera obusobozi nga tegyusa mirimu gya minisitule.',
    'The UGACCESS SDK does not intercept this form or change backend processing.':
        'UGACCESS SDK tekitwala foomu eno era tegyusa kukola kwa nyuma.',
    'Select a digital service. The UGACCESS widget can enlarge text, increase contrast, and stop animations.':
        'Londa empeereza ya kompyuta. Akakola ka UGACCESS kasobola okugaziya ennukuta, okwongera enjawulo, n’okulekerawo okwekyankalanya.',
    'Apply for an agricultural import permit. Processing takes five working days.':
        'Saba lupapa lw’okuleeta ebirime. Okukola kutwala ennaku ttaano ez’okukolera.',
    'Request a certified copy of a previously issued document.':
        'Saba kopi ekakasadwa ey’ekiwandiiko ekyawereddwa dda.',
    'Illustration of a government campus': 'Ekifaananyi ky’ekifo ky’obuyinza',
    'Skip to content': 'Buuka ku kirala',
    'Citizen services': 'Empeereza z’abantu',
    'Licensing and permits': 'Layisinsi n’olukusa',
    'Submit an application': 'Weereza okusaba',
    'Submit application': 'Weereza okusaba',
    'Start application': 'Tandika okusaba',
    'Application form': 'Foomu y’okusaba',
    'Service application': 'Okusaba empeereza',
    'Public service centre': 'Ekifo ky’empeereza y’abantu',
    'Certificate reprint': 'Okuddamu okufulumya satifikeeti',
    'Import permit': 'Olukusa lw’okuleeta',
    'Office hours': 'Essawa z’okukolera',
    'Monday – Friday': 'Mmande – Lwakkutaano',
    'Full name': 'Erinnya lyonna',
    'National ID': 'Endagamuntu',
    'Enter your full name': 'Yingiza erinnya lyo lyonna',
    Primary: 'Ekyasooka',
    Saturday: 'Lwamukaaga',
    Services: 'Empeereza',
    Service: 'Empeereza',
    Notes: 'Ebiwandiiko',
    Hours: 'Essawa',
    Home: 'Oluyiiya',
    Day: 'Olunaku',
};

const books: Record<string, PhraseBook> = {
    lug: luganda,
    nyn: {
        'Ministry Demo Portal': 'Orubuga rw’Obuhereza',
        'Skip to content': 'Guruka aha kiri mu nda',
        Home: 'Eka',
        Services: 'Emirimo',
        'Application form': 'Fomu y’okushaba',
        'Submit application': 'Tuma okushaba',
        'Full name': 'Eiziina ryona',
        'National ID': 'Endangamuntu',
        'Service application': 'Okushaba obuhereza',
        'Certificate reprint': 'Okushazamu satifikeeti',
        'Import permit': 'Olukusa rw’okutaaha',
        Notes: 'Ebihandiiko',
        Service: 'Obuhereza',
    },
    ach: {
        'Ministry Demo Portal': 'Kakube pa Minisita',
        'Skip to content': 'Pyen iye gin',
        Home: 'Gang',
        Services: 'Tic',
        'Application form': 'Waraga me kwayo',
        'Submit application': 'Cwal kwayo',
        'Full name': 'Nying duc',
        'National ID': 'Karatac me lobo',
        'Service application': 'Kwayo tic',
        Service: 'Tic',
        Notes: 'Coc',
    },
    teo: {
        'Ministry Demo Portal': 'Ewebusite lo Minisita',
        Home: 'Aju',
        Services: 'Aswam',
        'Application form': 'Eforma lo akilip',
        'Submit application': 'Silik akilip',
        'Full name': 'Ekieer kere',
        'National ID': 'Ekaratasi lo ajore',
        'Service application': 'Akilip aswam',
        Service: 'Aswam',
        Notes: 'Aiwat',
    },
    lgg: {
        'Ministry Demo Portal': 'Saiti ni Minisita',
        Home: 'Ayu',
        Services: 'Tici',
        'Application form': 'Fomu ni ele',
        'Submit application': 'Opi ele',
        'Full name': 'Ru dria',
        'National ID': 'Karatasi ni idri',
        'Service application': 'Ele tici',
        Service: 'Tici',
        Notes: 'Eti',
    },
};

export function phrasesFor(language: string): PhraseBook | null {
    return books[language] ?? null;
}

export function applyPhrases(text: string, phrases: PhraseBook): string {
    const entries = Object.entries(phrases).sort(
        (left, right) => right[0].length - left[0].length,
    );
    let result = text;

    entries.forEach(([english, translated]) => {
        const pattern = new RegExp(
            escapeRegExp(english).replace(/\s+/g, '\\s+'),
            'gi',
        );
        result = result.replace(pattern, translated);
    });

    return result;
}

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
